import React, { useEffect, useRef } from "react";
import ChatConversationItem from "../../../pages/ChatConversationItem";
import {
  Button,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SendIcon from "@mui/icons-material/Send";
import ClearIcon from "@mui/icons-material/Clear";
import { getInitials } from "../../../utils";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";

const ChatCenterForm = (props) => {
  const {
    chatDetail,
    selectedImage,
    activeUser,
    handleRemoveFile,
    handleFileChange,
    handleSendMessage,
    message,
    setMessage,
    fetchDataChat,
  } = props || {};

  const chatContainerRef = useRef(null);

  // Funkcija za scroll na dno
  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

  // Provera da li je korisnik došao do vrha
  /*const handleScroll = () => {
    if (chatContainerRef.current) {
      if (chatContainerRef.current.scrollTop === 0) {
        alert("Kraj! Učitavam starije poruke...");
        loadOlderMessages(); // Poziv funkcije za učitavanje starih poruka
      }
    }
  };*/

  // Dodavanje event listener-a na scroll
  //   useEffect(() => {
  //     const chatContainer = chatContainerRef.current;
  //     if (chatContainer) {
  //       chatContainer.addEventListener("scroll", handleScroll);
  //     }
  //     return () => {
  //       if (chatContainer) {
  //         chatContainer.removeEventListener("scroll", handleScroll);
  //       }
  //     };
  //   }, []);

  // Kada se sadržaj promeni, skroluje se na dno
  useEffect(() => {
    scrollToBottom();
  }, [chatDetail?.content]);

  const fullName = `${activeUser?.name} ${activeUser?.lastName}`;

  const reloadDataChat = (id = 1) => {
    fetchDataChat(id);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      reloadDataChat(0);
    }, 30000);

    return () => clearInterval(interval);
  }, [chatDetail?.content]);

  return (
    <div className="chat-center-content">
      <div className="chat-center-content-header">
        {activeUser?.image ? (
          <img src={activeUser?.image} className="img-fluid" />
        ) : (
          <div className="chat-center-content-header-initials">
            {getInitials(fullName)}
          </div>
        )}
        <div className="chat-center-content-header-holder">
          <div className="chat-center-content-header-holder-text">
            <div className="chat-center-content-header-name">
              {activeUser?.name} {activeUser?.lastName}
            </div>
            <div className="chat-center-content-header-company-name">
              {activeUser?.companyName} || {activeUser?.storeName}
            </div>
          </div>
        </div>
        <div className="chat-center-content-header-holder-reload">
          <Tooltip
            title="Osvežite poruke"
            disableInteractive
            placement="top"
            arrow={true}
          >
            <CachedOutlinedIcon onClick={() => reloadDataChat(1)} />
          </Tooltip>
        </div>
      </div>
      <div
        className="chat-center-content-center"
        ref={chatContainerRef}
        style={{ overflowY: "auto" }}
      >
        <div className="chat-center-content-center-holder">
          <ul>
            {chatDetail?.content
              ?.slice()
              .reverse()
              .map((item, index) => (
                <ChatConversationItem
                  data={item}
                  key={index}
                  image={activeUser.image}
                  fullName={fullName}
                />
              ))}
          </ul>
        </div>
      </div>
      <div className="chat-center-content-footer d-flex justify-content-between align-items-center gap-2">
        <input
          accept="image/*"
          style={{ display: "none" }}
          id="upload-image"
          type="file"
          onChange={handleFileChange}
        />
        <label htmlFor="upload-image">
          <IconButton component="span" color="primary">
            <AttachFileIcon />
          </IconButton>
        </label>
        {selectedImage && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body2" color="textSecondary" sx={{ ml: 1 }}>
              {selectedImage.name}
            </Typography>
            <IconButton
              onClick={handleRemoveFile}
              color="secondary"
              sx={{ ml: 1 }}
            >
              <ClearIcon />
            </IconButton>
          </div>
        )}
        <TextField
          label="Type your message..."
          size="small"
          type="text"
          name="message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          fullWidth
          multiline
          minRows={1}
          maxRows={1}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSendMessage();
            }
          }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSendMessage}
          endIcon={<SendIcon />}
        >
          Send
        </Button>
      </div>
    </div>
  );
};

export default ChatCenterForm;
